export default "__VITE_ASSET__Cng4mNBG__"